var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 252,
    viewBox: "0 0 260 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0001 42.98L52.5701 43.92L62.4101 152.1L59.2701 203.98L82.3001 217.24L84.1701 135.11L75.0001 42.98Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.99 43.29L185.54 42.6L187.55 151.21L180.66 202.73L202.68 217.62L210.48 135.84L207.99 43.29Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.66 44.13L98.4902 45.05L97.1602 136.02L106.39 212.52L127.14 208.96L120.02 106.4L122.66 44.13Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.01 45.4L150.95 194.38L169.34 204.31L164.2 49.75L139.01 45.4Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91992 160.42L6.42992 224.33L25.2799 251.09L64.0599 249.52L63.7099 236.87L31.0199 237.64L19.6499 219.6L16.3699 156.96L2.91992 160.42Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.2 152.76L258.54 216.76L240.9 244.33L202.09 244.49L201.88 231.83L234.56 231.15L245.12 212.62L245.61 149.9L259.2 152.76Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31 91.68L258.56 27.69L240.88 0.139999L202.07 0.0299988L201.88 12.69L234.57 13.33L245.15 31.84L245.73 94.56L259.31 91.68Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 91.73L0.66 27.73L18.3 0.16L57.11 0L57.33 12.66L24.64 13.34L14.08 31.87L13.59 94.59L0 91.73Z",
    fill: "#FFCC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 259.31,
    height: 251.09,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScan);
export default __webpack_public_path__ + "static/media/icon-scan.a7bf04b849a5d003e32a929f81d314f1.svg";
export { ForwardRef as ReactComponent };